<template>
  <div class="page-wrapper">
    <search-list  @findData="findData"></search-list>
    <div class="page-wrapper" >
      <table-list class="mt20" :columns="columns" :data="dataList" :loading="loading" :total="total" :current="current" @change-page="changePage" @refresh="findData"></table-list>
    </div>
    <head-img :n="headImgKey" :img="img"  :fid="fid"  @refresh="getPageList"></head-img>
    <intellect-img :n="intellectImgKey" :img="intellectImgUrl"  :click="intellectClickUrl":fid="fid"  @refresh="getPageList"></intellect-img>
    <img-config :n="imgConfigN" :fid="fid" :houseTypeFid="houseTypeFid" @refresh="getPageList"></img-config>
    <label-config :n="labelConfigN" :fid="fid" :houseTypeFid="houseTypeFid"></label-config>
    <market-tag :n="marketTagN" :fid="fid" :houseTypeFid="houseTypeFid" @refresh="getPageList"></market-tag>
    <kangfang :n="kanfangKey" :fid="fid" :houseTypeFid="houseTypeFid" @refresh="getPageList"></kangfang>
    <share-modal :n="shareKey" :fid="fid" :oldShareUrl = "shareUrl" @refresh="getPageList"></share-modal>
    <update-order :n="orderKey" :order="order" :fid="fid" @refresh="getPageList"></update-order>
    <qr-code-config :n="qrCodeKey" :fid="fid" :img="qrcodeUrl" @refresh="getPageList"></qr-code-config>
    <show-or-hide :n="showOrHideKey" :fid="fid" :houseTypeConfigStatus="houseTypeConfigStatus"  @refresh="getPageList"></show-or-hide>
    <search-tag :n="searchTagN" :houseTypeFid="houseTypeFid"></search-tag>
    <activity-list :n="activeN" :fid="fid" :houseTypeFid="houseTypeFid"></activity-list>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {getList} from "api/houseTypeConfig";
 // import {validConfig} from "api/projectConfig";
  import LabelConfig from './components/LabelConfig'
  import HeadImg from './components/HeadImg'
  import IntellectImg from './components/IntellectImg'
  import ImgConfig from './components/ImgConfig'
  import HouseTypeCofig from './components/HouseTypeCofig'
  import IconModal from './components/IconModal'
  import Kangfang from './components/Kanfang'
  import ShareModal from './components/ShareModal'
  import updateOrder from './components/updateOrder'
  import QrCodeConfig from './components/QrCodeConfig'
  import ShowOrHide from './components/ShowOrHide'
  import MarketTag from './components/MarketTag'
  import SearchTag from './components/SearchTag'
  import ActivityList from './components/ActivityList'


  export default {
    name: "houseTypeConfig",
    components:{
      ImgConfig,
      IntellectImg,
      SearchList,
      TableList,
      HeadImg,
      LabelConfig,
      HouseTypeCofig,
      IconModal,
      Kangfang,
      ShareModal,
      updateOrder,
      QrCodeConfig,
      ShowOrHide,
      MarketTag,
      SearchTag,
      ActivityList
    },
    data(){
      return {
        marketTagN:0,
        intellectImgKey:0,
        searchTagN:0,
        activeN: 0,
        labelConfigN: 0,
        img:'',
        intellectImgUrl:'',
        intellectClickUrl:'',
        fid:'',
        shareKey:0,
        shareUrl:'',
        kanfangKey:0,
        panoramicUrl:'',
        qrCodeKey:0,
        orderKey:0,
        order:0,
        // qrCodeKey:0,
        qrcodeUrl:'',
        showOrHideKey:0,
        houseTypeConfigStatus:0,
        houseTypeFid:'',
        projectFid:'',
        imgConfigN:0,
        headImgKey:0,
        statusData:{},
        statusN:0,
        searchData: {
          page:1,
          limit:10,
          houseTypeConfigStatus:'',
          q:''
        },
        current:1,
        total: 0,
        dataList:[],
        loading:false,
        columns:[
          // {
					// 	type:'index',
					// 	width:60,
					// 	align:'center'
					// },
          {
            title: "房型名称",
            key: "houseTypeName",
            align: "center",
            fixed:'left',
            width:200
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
            width:180
          },
          {
            title: "显示顺序",
            key: "configOrder",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.order = params.row.configOrder
                    this.fid=params.row.fid
                    this.orderKey++
                  }
                }
              },params.row.configOrder)
            }
          },
          {
            title: "房型头图",
            key: "headImg",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.img = params.row.headImg
                    this.fid=params.row.fid
                    this.headImgKey++
                  }
                }
              },'配置')
            }
          },
          {
            title: "多媒体配置",
            width:100,
            key: "panoramicUrl",
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.panoramicUrl = params.row.panoramicUrl
                    this.houseTypeFid=params.row.houseTypeFid
                    this.fid=params.row.fid
                    this.kanfangKey++
                  }
                }
              },'链接')
            }
          },
          {
            title: "图片配置",
            // key: "keyC",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row.fid
                    this.houseTypeFid=params.row.houseTypeFid
                    // this.img = params.row.headImg
                    this.imgConfigN++
                  }
                }
              },'配置')
            }
          },
          {
            title: "特色标签",
            key: "keyD",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.houseTypeFid=params.row['houseTypeFid']
                    this.labelConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "活动运营",
            width:100,
            key: "keyC2",
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row.fid
                    this.houseTypeFid=params.row.houseTypeFid
                    this.marketTagN++
                  }
                }
              },'配置')
            }
          },
          {
            title: "智能化配置",
            key: "intellectImg",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.intellectImgUrl = params.row.intellectImgUrl
                    this.intellectClickUrl = params.row.intellectClickUrl
                    this.fid=params.row.fid
                    this.intellectImgKey++
                  }
                }
              },'配置')
            }
          },
          {
            title: "二维码",
            width:100,
            key: "qrcodeUrl",
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row.fid
                    this.qrcodeUrl = params.row.qrcodeUrl
                    this.qrCodeKey++
                  }
                }
              },'配置')
            }
          },
          {
            title: "分享链接",
            key: "shareUrl",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row.fid
                    this.shareUrl = params.row.shareUrl
                    this.shareKey++
                  }
                }
              },'链接')
            }
          },
          {
            title: "操作",
            width:100,
            key: "action",
            align: "center",
            render:(h,params)=>{
              return h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'houseTypeConfig/showOrForbid'
                    }
                  }
                ],
                on:{
                  click:()=>{
                   this.fid=params.row.fid
                   this.houseTypeConfigStatus = params.row.status==1 ? 0 : 1
                    this.showOrHideKey++
                  }
                }
              },params.row.status==1?'隐藏':'显示')
            }
          },
            {
                title: "搜索配置",
                //key: "keyC2",
                width:100,
                align: "center",
                render:(h,params)=>{
                    return h('a',{
                        on:{
                            click:()=>{
                                this.houseTypeFid=params.row['houseTypeFid']
                                this.searchTagN++
                            }
                        }
                    },'配置')
                }
            },
            {
                                  title: "活动配置",
                                  width:100,
                                  key: "keyI",
                                  align: "center",
                                  render:(h,params)=>{
                                    return h('a',{
                                      on:{
                                        click:()=>{
                                        this.houseTypeFid=params.row['houseTypeFid']
                                          this.fid=params.row['fid']
                                          this.activeN++
                                        }
                                      }
                                    },'配置')
                        }
            },
        ],
        // status1Value:'3',//即将开业  默认值
      }
    },
    methods:{
      findData(value){
        this.current=1
        this.searchData.page = 1
        this.searchData=Object.assign(value)
        this.getPageList()
      },
      getPageList(){
        getList(this.searchData).then(res=>{
          // console.log(res.data.rows)
           this.dataList=res.data.rows
          this.total=res.data.total
        })
      },
      changePage(n){
        this.searchData.page=n
        this.current=n
        this.getPageList()
      }
    },
    created(){
      this.getPageList()
    }
  }
</script>

<style scoped>

</style>
